import { useEffect } from 'react';
import { AppState } from '@/types';
import { checkAndApplyMonthlyReset } from '@/utils/monthlyReset';

export function useMonthlyReset(state: AppState, dispatch: any, setAppState: (state: AppState) => Promise<void>) {

  // Check for monthly reset on app startup and when tab becomes visible
  useEffect(() => {
    const checkMonthlyReset = () => {
      if (state.isAuthenticated) {
        const stateWithMonthlyReset = checkAndApplyMonthlyReset(state);
        
        // If the state changed due to monthly reset, update it
        if (stateWithMonthlyReset.currentMonthPoints !== state.currentMonthPoints ||
            stateWithMonthlyReset.monthlyStartDate !== state.monthlyStartDate) {
          if (import.meta.env.DEV) console.log('🗓️ Monthly reset detected, updating state');
          
          // Update the state with reset values
          dispatch({
            type: 'RESET_MONTHLY_STATS'
          });
        }
      }
    };

    // Check on initial load
    checkMonthlyReset();

    // Check when tab becomes visible (user returns to app)
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkMonthlyReset();
      }
    };

    // Check every day for monthly reset
    const interval = setInterval(checkMonthlyReset, 24 * 60 * 60 * 1000); // 24 hours

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [state, dispatch]);
}